import { useState } from "react";
import { Link } from "react-router-dom";
import { useCafeLogs } from "../hooks/useCafeLogs";
import type { CafeLog } from "../types";
import { photoUrl } from "../lib/photos";

export function CafeLog() {
  const [q, setQ] = useState("");
  const params: Record<string, string> = {};
  if (q.trim()) params.q = q.trim();
  const { data, error } = useCafeLogs(params);

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h2 className="font-display text-3xl">Café Log</h2>
          <p className="text-sm text-paper-600">Coffees you've had out of the house.</p>
        </div>
        <Link to="/cafe/new" className="btn-primary shrink-0">+ New entry</Link>
      </div>

      <input
        className="input-box"
        placeholder="Search café, city, bean, roaster, notes…"
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />

      {error ? <div className="border border-red-300 bg-red-50 text-red-800 px-3 py-2 text-sm">{error}</div> : null}

      {data == null ? (
        <p className="text-paper-500 text-sm">Loading…</p>
      ) : data.length === 0 ? (
        <div className="border border-paper-200 p-8 text-center text-paper-500 text-sm">
          No entries yet. Had a great coffee out? <Link to="/cafe/new" className="underline">Log it →</Link>
        </div>
      ) : (
        <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {data.map((log) => <CafeLogCard key={log.id} log={log} />)}
        </ul>
      )}
    </div>
  );
}

function CafeLogCard({ log }: { log: CafeLog }) {
  const thumb = photoUrl(log.photos[0]?.r2_key);
  const bean = [log.variety, log.country].filter(Boolean).join(" · ");
  return (
    <li className="border border-paper-200 bg-paper-50 hover:border-ink transition-colors">
      <Link to={`/cafe/${log.id}`} className="block">
        <div className="aspect-[4/3] bg-paper-100 overflow-hidden border-b border-paper-200">
          {thumb ? (
            <img src={thumb} alt="" className="h-full w-full object-cover" />
          ) : (
            <div className="h-full w-full flex items-center justify-center text-paper-300 text-5xl font-display">
              {log.cafe_name.slice(0, 1).toUpperCase()}
            </div>
          )}
        </div>
        <div className="p-3 space-y-1">
          <div className="flex items-start justify-between gap-2">
            <div className="font-display text-lg leading-tight">{log.cafe_name}</div>
            {log.score != null ? (
              <span className="text-xs uppercase tracking-widest text-paper-500 shrink-0">
                <span className="text-ink tabular-nums">{log.score.toFixed(log.score % 1 === 0 ? 0 : 2)}</span>
              </span>
            ) : null}
          </div>
          {log.cafe_city ? <div className="text-xs text-paper-500">{log.cafe_city}</div> : null}
          {bean ? <div className="text-sm text-paper-700">{bean}</div> : null}
          {log.visited_on ? <div className="text-[11px] uppercase tracking-widest text-paper-400 pt-1">{log.visited_on}</div> : null}
        </div>
      </Link>
    </li>
  );
}
